import React from 'react'
import Spinner from 'react-bootstrap/Spinner';

function PageLoader({isLoading}) {
    return (
        <div className={`modal fade ${isLoading && "show d-block loader-bg-color"}`}  id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content text-center border-0">
                    <div className="modal-body">
                        <Spinner animation="border" variant="primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageLoader
